import { CHANGE_BOOKMAKER_EXTEND } from "./actionTypes";
import { BANKER_EXTENDS } from "@/contants";

const BookmarkerExtendReducer = (state: string = BANKER_EXTENDS[0].value, action: any) => {
  switch (action.type) {
    case CHANGE_BOOKMAKER_EXTEND:      
      return action.payload;
    default:
      return state;
  }
};

export default BookmarkerExtendReducer;
